import React from "react"
import cs from 'classnames'
import styles from './WizardButtons.scss'

function WizardButtons(props) {
    const { leftBtn, cancelBtn, nextBtn, previousBtn, middleActionBtn } = props

    const renderBtn = (btnData, style) => {
        const { disabled, method, isHidden, label } = btnData
        return isHidden ? '' : (
            <button
                type="button"
                className={style}
                disabled={disabled}
                onClick={(e) => {
                    e.preventDefault()
                    method()
                }}
            >
                {label}
            </button>
        )

    }

    return (
        <div className={styles.buttonsWrapper}>
            <div className={cs(styles.modalButtons, styles.leftBtnContainer)}>
                {leftBtn && !leftBtn.isHidden &&
                    renderBtn(leftBtn, styles.greenButton + " enabled")
                }
            </div>
            <div className={styles.modalButtons}>
                {cancelBtn &&
                    <div
                        onClick={cancelBtn.method}
                        className={styles.cancel}
                    >
                        {cancelBtn.label}
                    </div>
                }

                {previousBtn && !previousBtn.isHidden && renderBtn(previousBtn, styles.greenButton + " enabled")}
                {middleActionBtn && !middleActionBtn.isHidden && renderBtn(middleActionBtn, styles.greenButton + " enabled")}
                {nextBtn && renderBtn(nextBtn, styles.greenButton + " enabled")}
            </div>
        </div>
    )
}

export default WizardButtons



// WEBPACK FOOTER //
// ./components/ClaimsWizard/shared/WizardButtons/WizardButtons.jsx